"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.htmlFontSizeAdjust = exports.htmlFontSize = exports.fontWeightRegular = exports.fontWeightMedium = exports.fontWeightLight = exports.fontWeightBold = exports.fontFamilyCondensed = exports.fontFamily = void 0;
var fontFamily = exports.fontFamily = 'SansOri, SansOriFallback, sans-serif';
var fontFamilyCondensed = exports.fontFamilyCondensed = 'SansCondensedOri, SansCondensedOriFallback, sans-serif';
var fontWeightLight = exports.fontWeightLight = 400;
var fontWeightRegular = exports.fontWeightRegular = 400;
var fontWeightMedium = exports.fontWeightMedium = 700;
var fontWeightBold = exports.fontWeightBold = 700;
var htmlFontSize = exports.htmlFontSize = 10;
var htmlFontSizeAdjust = exports.htmlFontSizeAdjust = '62.5%'; //# sourceMappingURL=font.js.map
